var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    {
      attrs: { title: _vm.$t("mandate.mode_choice_title") || "Choix du mode" },
    },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-container",
            { attrs: { fluid: "" } },
            [
              _c(
                "b-row",
                { staticClass: "justify-content-center mt-4" },
                [
                  _c(
                    "b-col",
                    { staticClass: "mb-4", attrs: { cols: "12", md: "6" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "mode-card",
                          on: { click: _vm.goToBankSelection },
                        },
                        [
                          _c("h4", { staticClass: "mode-card-title" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("mandate.mode_bank_title") ||
                                  "Se connecter à mon ancienne banque"
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "mode-card-desc" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$t("mandate.mode_bank_desc") ||
                                    "Je m'authentifie auprès de mon ancienne banque et autorise la récupération de mes opérations de prélèvements et de virements"
                                ) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              staticClass: "btnFilter_2",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.goToBankSelection.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t("mandate.choose_mode") ||
                                      "Choisir ce mode"
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "mb-4", attrs: { cols: "12", md: "6" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "mode-card",
                          on: { click: _vm.goToManualForm },
                        },
                        [
                          _c("h4", { staticClass: "mode-card-title" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("mandate.mode_manual_title") ||
                                  "Formulaire de saisie"
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "mode-card-desc" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$t("mandate.mode_manual_desc") ||
                                    "Je saisie manuellement mes émetteurs et pour chacun d'eux les opérations de prélèvements de virements associées"
                                ) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              staticClass: "btnFilter_2",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.goToManualForm.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t("mandate.choose_mode") ||
                                      "Choisir ce mode"
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }